var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"multiple":"","options":_vm.$store.getters['data/allMonetaryActions']},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-select',_vm.selectProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }